import i18n, { resources } from '../i18n'

export const getLanguage = () => {
  const currentLanguage = i18n.language
  const resource = resources[currentLanguage]

  return resource ? currentLanguage : 'pt-BR'
}
